export const niveisEscolares = [
  "Nível Fundamental Completo",
  "Nível Fundamental Incompleto",
  "Nível Médio Completo",
  "Nível Médio Incompleto",
  "Nível Superior Completo",
  "Nível Superior Incompleto",
];
